export class GetTemplates {
    static readonly type = '[Templates] Get';
    constructor(public pageIdex: number) {}
}